var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Banner from './components/Banner';
const PartnerOfferBanner = ({ partnersPackages, userId }) => {
    const [isAddDocumentsEnabled, setAddDocumentsEnabled] = useState(true);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const basketResponse = yield axios.get('/api/basket');
                if (basketResponse.data.items.length > 0) {
                    setAddDocumentsEnabled(false);
                }
            }
            catch (error) {
                console.error(error);
            }
        }))();
    }, []);
    return partnersPackages.map((partnerPackage) => {
        if (!partnerPackage.is_package || !partnerPackage.partner_info.package_activated) {
            return null;
        }
        return (_jsx(Banner, { packageInfo: partnerPackage, userId: userId, isAddDocumentsEnabled: isAddDocumentsEnabled }, partnerPackage.partner));
    });
};
PartnerOfferBanner.propTypes = {
    partnersPackages: PropTypes.array.isRequired,
    userId: PropTypes.number.isRequired
};
export default PartnerOfferBanner;
